export function hasCoordinates(story) {
  return story && ['lat', 'lng'].every(key => story[key] !== null && story[key] !== undefined && String(story[key]).trim() !== '' && Number.isFinite(Number(story[key]))) && Math.abs(Number(story.lat)) <= 90 && Math.abs(Number(story.lng)) <= 180;
}
export function nearestStories(current, stories, limit = 6) {
  if (!hasCoordinates(current)) return [];
  const radians = value => Number(value) * Math.PI / 180;
  return stories.filter(story => String(story.id) !== String(current.id) && hasCoordinates(story)).map(story => {
    const a = Math.sin((radians(story.lat) - radians(current.lat)) / 2) ** 2 + Math.cos(radians(current.lat)) * Math.cos(radians(story.lat)) * Math.sin((radians(story.lng) - radians(current.lng)) / 2) ** 2;
    return { ...story, distanceKm: 6371 * 2 * Math.asin(Math.sqrt(Math.min(1, Math.max(0, a)))) };
  }).sort((a, b) => a.distanceKm - b.distanceKm || String(a.id).localeCompare(String(b.id))).slice(0, limit);
}
export function formatDistance(km) {
  return km < 1 ? `${Math.round(km * 1000)} 米` : `${km.toFixed(1)} 公里`;
}
